var _rect, _rect2, _path, _rect3, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechniusLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1246,
    height: 1245,
    viewBox: "0 0 1246 1245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1245,
    height: 1245,
    transform: "translate(0.126953)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1245,
    height: 1245,
    transform: "translate(0.126953)",
    fill: "url(#paint0_linear_1_2)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M729.243 392.434C769.874 403.321 783.483 454.11 753.738 483.854L433.263 804.33C403.519 834.074 352.73 820.465 341.842 779.834L224.54 342.056C213.653 301.425 250.833 264.245 291.465 275.132L729.243 392.434Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 233.184,
    y: 905.205,
    width: 774.697,
    height: 162.426,
    rx: 81.2129,
    transform: "rotate(-15 233.184 905.205)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 914.08,
    cy: 307.587,
    r: 81.535,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: 0.00000315527,
    y1: 1245,
    x2: 1245,
    y2: 0.00000315527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B75BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49152,
    stopColor: "#6B2C90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB008B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechniusLogo);
export default __webpack_public_path__ + "static/media/TechniusLogo.c08c1631cd7e9cdd77181c65bd500380.svg";
export { ForwardRef as ReactComponent };